import React from "react";

import BurgerBtn from "./Icons/BurgerBtn";
import ProfileIcon from "./Icons/ProfileIcon";
import LoginIcon from "./Icons/LoginIcon";
import SignUpIcon from "./Icons/SignUpIcon";
import MenuButton from "./AppMenu/MenuButton";
import LogoNameHorizontal from "./Icons/LogoNameHorizontal";
import Logo from "./Icons/Logo";
import LogoutButton from "./Buttons/LogoutButton";
import ButtonPrimary from "./Buttons/ButtonPrimary";
import Button from "./Buttons/Button";
import DownArrowIcon from "./Icons/DownArrowIcon";
import MediaQuery from "react-responsive";

export const LabeledCheckBox = ({ label, checked, onChange, disabled }) => (
    <label style={{ opacity: disabled ? 0.5 : 1 }} className="virtue-checkbox virtue-control-checkbox">
        &nbsp;{label}
        <input type="checkbox" disabled={disabled} checked={checked} onChange={onChange} />
        <div className="virtue-control-indicator"></div>
    </label>
);

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openMenu: false,
            learnView: `${window.location.href}`.endsWith("/learn/")
        };
    }
    onClickBurger = () => {
        this.setState({
            openMenu: !this.state.openMenu,
        });
    };

    render() {
        const { openMenu, learnView } = this.state;
        return (
            <>
                <div className={`${learnView ? "w-full flex justify-between pt-[15px] pl-[15px] z-[999]" : "navbar-mobile-new-ui-bg"} lg:hidden`}>

                    <MediaQuery minWidth={451}>
                        <LogoNameHorizontal />
                    </MediaQuery>
                    <MediaQuery maxWidth={450}>
                        <Logo />
                    </MediaQuery>
                    {this.props.currentUser ? (
                        <div className="flex flex-row items-center gap-4 mr-[24px]">
                            {!learnView && <p className="cursor-pointer font-poppins text-[12px] font-bold text-white">
                                {this.props.currentUser?.username}
                            </p>}
                            
                            <ProfileIcon currentAvatar={this.props.currentAvatar} variant="smallProfileIcon" />
                            <Button variant={openMenu ? "closeMenu" : "openMenu"} onClick={this.onClickBurger}>
                                <DownArrowIcon />
                            </Button>
                        </div>
                    ) : (
                        <div className="flex flex-row items-center gap-4 mr-[24px]">
                            <Button variant={"signupButton"} href={"/accounts/signup"} children={"Sign Up"} />
                            <a href="/accounts/login" className="text-white">Log in</a>
                            <BurgerBtn active={openMenu} onClick={this.onClickBurger} />
                        </div>
                    )}
                </div>

                <div
                    className={`virtue-desktop-menu ${learnView ? "!top-[50px] !z-[1000]" : ""} bg-[#18202E]`}
                    style={{ visibility: openMenu ? "visible" : "hidden" }}
                >
                    <div
                        className={`flex flex-col justify-center px-5 text-white lg:hidden ${
                            openMenu ? "items-center" : ""
                        }`}
                        style={{ pointerEvents: "auto" }}
                    >
                        {global.props?.NAVBAR_OPTIONS.map((option) => (
                            <ButtonPrimary
                                key={option.key}
                                href={option.href}
                                gray={!option.active}
                                className="h-[60px] w-full max-w-[360px] rounded-[10px]"
                                disabled={option.disabled}
                            >
                                <div className="flex items-center w-full h-full gap-6 pl-6">
                                    <img src={option.icon} alt={option.label} />
                                    <div className="flex flex-col items-start justify-center">
                                        <span className="text-[12px]">{option.label}</span>
                                        {option.tooltip && <span className="mt-1 text-[8px]">{option.tooltip}</span>}
                                    </div>
                                </div>
                            </ButtonPrimary>
                        ))}
                        {openMenu &&
                            (this.props.currentUser ? (
                                <div className="flex flex-col items-center w-full h-full mt-4">
                                    <ProfileIcon currentAvatar={this.props.currentAvatar} />
                                    <a
                                        href="/player/account-info"
                                        className="btn-blue-secondary regular-text mt-4 flex h-[44px] w-[132px] cursor-pointer items-center justify-center"
                                    >
                                        {this.props.currentUser?.username}
                                    </a>
                                    {this.props.currentUser && <LogoutButton className="text-red-500 flex cursor-pointer items-center justify-center mt-3 underline decoration-1" />}
                                </div>
                            ) : (
                                <div className="mt-[10px] flex">
                                    <MenuButton
                                        label="Log In"
                                        icon={<LoginIcon />}
                                        active={false}
                                        href={`/accounts/login/?next=${window.location.pathname}`}
                                        id="login"
                                        className="mr-10"
                                    ></MenuButton>
                                    <MenuButton
                                        label="Sign Up"
                                        icon={<SignUpIcon />}
                                        active={false}
                                        href="/accounts/signup"
                                        id="signup"
                                    ></MenuButton>
                                </div>
                            ))}
                    </div>
                </div>
            </>
        );
    }
}

export default Navbar;
